// ConsultationList.js
import React, { useEffect, useState } from 'react';
import { Table, Spin } from 'antd';
import moment from 'moment';
import ProjectServices from '../../../../services/projectServices';

const ConsultationList = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await ProjectServices.getConsultationData();
        setData(response.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const columns = [
    { title: 'Full Name', dataIndex: 'full_name', key: 'full_name' },
    { title: 'Email', dataIndex: 'email', key: 'email' },
    { title: 'Phone Number', dataIndex: 'phone_number', key: 'phone_number' },
    { title: 'Organization', dataIndex: 'organization_name', key: 'organization_name' },
    { title: 'Job Title', dataIndex: 'job_title', key: 'job_title' },
    { title: 'Decision Maker', dataIndex: 'decision_maker', key: 'decision_maker' },
    { title: 'Industry', dataIndex: 'industry', key: 'industry' },
    { title: 'Organization Size', dataIndex: 'organization_size', key: 'organization_size' },
    { title: 'Location', dataIndex: 'location', key: 'location' },
    {
      title: 'Preferred Demo Time',
      dataIndex: 'preferred_demo_time',
      key: 'preferred_demo_time',
      render: (date) => moment(date).format('YYYY-MM-DD HH:mm'),
    },
    {
      title: 'Submitted At',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (date) => moment(date).format('YYYY-MM-DD HH:mm'),
    },
  ];

  if (loading) {
    return <Spin size="large" style={{ display: 'block', margin: '100px auto' }} />;
  }

  return (
    <div style={{ padding: '20px' }}>
        <h2>Consultation Requests</h2>
        <br/>
      <Table
        dataSource={data}
        columns={columns}
        rowKey={(record) => record.email}
        pagination={{ pageSize: 5 }}
      />
    </div>
  );
};

export default ConsultationList;
